import { booleanToGateBoolean, gateBooleanToBoolean } from "@sg-core/index"
import { processValue } from "../../sg-schema/themes/semantic/components/DateTimePicker/DateTimePicker.utils";


export interface IPersonCert {
    id: number;
    name?: string;
    refrenceName: string;
    number?: string;
    startsAt?: string;
    endsAt?: string;
    valid?: boolean;
    expires?: boolean;
    cardImage?: string;
    timelimited?: boolean | null
};


export type IPersonCertFormData = Partial<Omit<IPersonCert, "id">>;


export interface IPersonCertDTO {
    id: number;
    nimi?: string;
    viitenimi: string;
    numero?: string;
    alkaa?: string;
    paattyy?: string;
    voimassa?: string | "Y" | "N";
    vanhenee?: string | "Y" | "N";

    tunniste?: string;
    korttikuva?: string;
};



export const PersonCertMapper = {

    domainToApi: (domain: IPersonCert): IPersonCertDTO => {
        const valid = (domain.timelimited && !domain.startsAt && !domain.endsAt) ? false : domain.valid;

        return ({
            id: domain.id,
            nimi: domain.name,
            viitenimi: domain.refrenceName,
            numero: domain.number,
            tunniste: domain.number,
            alkaa: domain.startsAt ? processValue(domain.startsAt, undefined, "date") : undefined,
            paattyy: domain.endsAt ? processValue(domain.endsAt, undefined, "date") : undefined,
            korttikuva: domain.cardImage,
            voimassa: typeof valid !== "undefined" ? booleanToGateBoolean(valid) : "",
        })
    },

    apiToDomain: (api: IPersonCertDTO): IPersonCert => {

        return ({
            id: api.id,
            name: api.nimi,
            refrenceName: api.viitenimi,
            number: api.numero || api.tunniste,
            cardImage: api.korttikuva,
            startsAt: api.alkaa ? api.alkaa.split(" ")[0] : undefined,
            endsAt: api.paattyy ? api.paattyy.split(" ")[0] : undefined,

            valid: api.voimassa ? gateBooleanToBoolean(api.voimassa) : false,
            expires: api.vanhenee ? gateBooleanToBoolean(api.vanhenee) : false,
            timelimited: null
        })
    }

};
